import { render, staticRenderFns } from "./Cgu.vue?vue&type=template&id=1d5a7f74"
import script from "./Cgu.vue?vue&type=script&lang=js"
export * from "./Cgu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports